import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useField } from 'formik'

type AutocompleteProps = {
  label?: string
  name: string
  options: Array<any>
  onChange?: (e, value) => void
  disabled?: boolean
  multiple
}

const ValidatedAutocomplete = (props: AutocompleteProps) => {
  const { label, options, onChange, name, disabled, multiple } = props
  const [field, meta] = useField(name)
  const error = !!(meta.error && meta.touched)
  const helperText = error ? meta.error : null
  const placeHolderText = meta?.value?.length >= 1 ? '' : 'Click or type to add tags'

  return (
    <Autocomplete
      multiple={multiple}
      options={options}
      onChange={onChange ? onChange : field.onChange}
      filterSelectedOptions
      value={meta.value}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          name={name}
          error={error}
          variant="outlined"
          label={label}
          InputLabelProps={{ shrink: true }}
          onBlur={field.onBlur}
          helperText={helperText}
          disabled={disabled}
          multiline={true}
          placeholder={placeHolderText}
        />
      )}
    />
  )
}

export default ValidatedAutocomplete
